import { IOffer } from '../../../types/offer';

export function isGarage(offer: IOffer) {
  return offer.category === 'garageSale' || offer.category === 'garageRent';
}
